/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { URL_API } from "../config/default";
import Swal, { SweetAlertOptions } from "sweetalert2";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { CustomToast } from "../utils/custom-toast";
import { Card, CardContent, CardFooter } from "../components/UI/Card";
import { Input } from "../components/UI/Input";
import { Eye, EyeOff, Lock, Mail } from "lucide-react";
import { Checkbox } from "../components/UI/checkbox";
import { Link } from "react-router-dom";

const Register = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [register, setRegister] = useState(false);
  const [showPassword, setShowPassword] = useState(false)
  const [auth, setAuth] = useState<any>({
    firstname: "",
    lastname: "",
    phone: "",
    address: "",
    timezone: "America/Buenos_Aires",
    lang: "ESP",
    currency: "ARS",
    email: "",
    password: "",
  });

  useEffect(() => {
    const registerParam = searchParams.get('register');
    if (registerParam === '1') {
      setRegister(true);
    }
  }, [searchParams]);

  const submit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    const formdata = new FormData();
    formdata.append("email", auth.email);
    formdata.append("password", auth.password);

    const requestOptions = {
      method: "POST",
      body: formdata,
    };

    fetch(`${URL_API}/auth/login`, requestOptions)
      .then(async (response) => {
        if (response.ok) {
          const result = await response.json();
          localStorage.removeItem("token");
          localStorage.setItem("token", result.token);
          CustomToast({
            status: 200,
            msg: "",
            title: "Bienvenido a Rumbo Punilla!",
          });
          setTimeout(() => {
            setLoading(false);
            const reserva = localStorage.getItem("reserva");
            return (window.location.href = reserva ? "/reservar" : "/");
          }, 1000)
        } else {
          setLoading(false);
          return CustomToast({
            status: 400,
            msg: "",
            title: "Ocurrio un error con su email o contraseña!",
          });
        }
      })
      .catch((error) => console.error(error));
  };

  const onRegister = async () => {
    const formdata = new FormData();

    if (
      auth.firstname.trim() == "" ||
      auth.lastname.trim() == "" ||
      auth.phone.trim() == "" ||
      auth.address.trim() == "" ||
      auth.email.trim() == "" ||
      auth.password.trim() == ""
    ) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      } as SweetAlertOptions);
      Toast.fire({
        icon: "error",
        title: "Todos los campos son obligatorios",
      });
    }

    setLoading(true);
    formdata.append("firstname", auth.firstname);
    formdata.append("lastname", auth.lastname);
    formdata.append("phone", auth.phone);
    formdata.append("address", auth.address);
    formdata.append("timezone", auth.timezone);
    formdata.append("lang", auth.lang);
    formdata.append("currency", auth.currency);
    formdata.append("email", auth.email);
    formdata.append("password", auth.password);

    const requestOptions = {
      method: "POST",
      body: formdata,
    };

    fetch(`${URL_API}/auth/register`, requestOptions)
      .then(async (response) => {
        await response.json();
        Swal.fire({
          title: "Bienvenido a Rumbo Punilla.",
          text: "Se envio un correo para verificar su email.",
          icon: "success",
          showConfirmButton: false,
        });
        setLoading(false);
        //setOpenModal(false);
        const reserva = localStorage.getItem("reserva");
        return (window.location.href = reserva ? "/reservar" : "/");
      })
      .catch((error) => console.error(error));
  };

  if (register) {
    return (
      <main className="container mx-auto px-4 py-8 sm:py-12">
        <div className="max-w-md mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Crear Cuenta</h1>
            <p className="text-gray-600">Te damos la bienvenida a Rumbo Punilla</p>
          </div>
          <Card className="shadow-lg">
            <form onSubmit={(e) => { e.preventDefault(); onRegister(); }}>
              <CardContent className="p-6 space-y-4">
                {/* Nombre */}
                <div className="space-y-2">
                  <label htmlFor="firstname" className="text-sm font-medium text-gray-700">
                    Nombre
                  </label>
                  <Input
                    id="firstname"
                    type="text"
                    placeholder="Tu nombre"
                    value={auth?.firstname}
                    onChange={(e) => setAuth({ ...auth, firstname: e.target.value })}
                    required
                  />
                </div>

                {/* Apellido */}
                <div className="space-y-2">
                  <label htmlFor="lastname" className="text-sm font-medium text-gray-700">
                    Apellido
                  </label>
                  <Input
                    id="lastname"
                    type="text"
                    placeholder="Tu apellido"
                    value={auth?.lastname}
                    onChange={(e) => setAuth({ ...auth, lastname: e.target.value })}
                    required
                  />
                </div>

                {/* Teléfono */}
                <div className="space-y-2">
                  <label htmlFor="phone" className="text-sm font-medium text-gray-700">
                    Teléfono
                  </label>
                  <Input
                    id="phone"
                    type="tel"
                    placeholder="Tu número de teléfono"
                    value={auth?.phone}
                    onChange={(e) => setAuth({ ...auth, phone: e.target.value })}
                    required
                  />
                </div>

                {/* Dirección */}
                <div className="space-y-2">
                  <label htmlFor="address" className="text-sm font-medium text-gray-700">
                    Dirección
                  </label>
                  <Input
                    id="address"
                    type="text"
                    placeholder="Tu dirección"
                    value={auth?.address}
                    onChange={(e) => setAuth({ ...auth, address: e.target.value })}
                    required
                  />
                </div>

                {/* Email */}
                <div className="space-y-2">
                  <label htmlFor="email" className="text-sm font-medium text-gray-700">
                    Correo electrónico
                  </label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                    <Input
                      id="email"
                      type="email"
                      placeholder="tu@email.com"
                      value={auth?.email}
                      onChange={(e) => setAuth({ ...auth, email: e.target.value })}
                      className="pl-10"
                      required
                    />
                  </div>
                </div>

                {/* Password */}
                <div className="space-y-2">
                  <label htmlFor="password" className="text-sm font-medium text-gray-700">
                    Contraseña
                  </label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                    <Input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="••••••••"
                      value={auth?.password}
                      onChange={(e) => setAuth({ ...auth, password: e.target.value })}
                      className="pl-10 pr-10"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                    </button>
                  </div>
                </div>

                {/* Submit Button */}
                <button className="btn w-full btn-filled-2" disabled={loading}>
                  {loading ? "Creando cuenta..." : "Continuar"}
                </button>
              </CardContent>

              <CardFooter className="px-6 py-4 bg-gray-50">
                <p className="text-sm text-gray-600 text-center w-full">
                  ¿Ya tienes una cuenta?
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      searchParams.delete("register");
                      setSearchParams(searchParams);
                      setRegister(false);
                    }}
                    className="btn w-full btn-outline-2"
                  >
                    Inicia sesión aquí
                  </button>
                </p>
              </CardFooter>
            </form>
          </Card>
        </div>
      </main>
    )
  }

  return (
    <main className="container mx-auto px-4 py-8 sm:py-12">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Iniciar Sesión</h1>
          <p className="text-gray-600">Accede a tu cuenta de Rumbo Punilla</p>
        </div>
        <Card className="shadow-lg">
          <form onSubmit={(e) => {
            e.preventDefault();
            submit(e)
          }}>
            <CardContent className="p-6 space-y-4">
              {/* Email */}
              <div className="space-y-2">
                <label htmlFor="email" className="text-sm font-medium text-gray-700">
                  Correo electrónico
                </label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <Input
                    id="email"
                    type="email"
                    placeholder="tu@email.com"
                    value={auth?.email}
                    onChange={(e) => setAuth({ ...auth, email: e.target.value })}
                    className="pl-10"
                    required
                  />
                </div>
              </div>

              {/* Password */}
              <div className="space-y-2">
                <label htmlFor="password" className="text-sm font-medium text-gray-700">
                  Contraseña
                </label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <Input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="••••••••"
                    value={auth?.password}
                    onChange={(e) => setAuth({ ...auth, password: e.target.value })}
                    className="pl-10 pr-10"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>

              {/* Remember me & Forgot password */}
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <Checkbox id="remember" checked={false} onCheckedChange={() => { }} />
                  <label htmlFor="remember" className="text-sm text-gray-600">
                    Recordarme
                  </label>
                </div>
                <Link to="/recuperar-contraseña" className="text-sm text-[#8B9456] hover:text-[#7A8249]">
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>

              {/* Submit Button */}
              <button type="submit" className="btn w-full btn-filled-2" disabled={loading}>
                {loading ? "Iniciando sesión..." : "Iniciar Sesión"}
              </button>

              {/* Divider */}
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <span className="w-full border-t" />
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-white px-2 text-gray-500">O continúa con</span>
                </div>
              </div>
            </CardContent>

            <CardFooter className="px-6 py-4 bg-gray-50">
              <p className="text-sm text-gray-600 text-center w-full">
                ¿No tienes una cuenta?
                <button
                type="button"
                  className="btn w-full btn-outline-2 w-full"
                  onClick={(e) => {
                    e.preventDefault();
                    if (!register) {
                      searchParams.set("register", "1");
                      setSearchParams(searchParams);
                    } else {
                      searchParams.delete("register");
                    }
                    setRegister(!register)
                  }}>
                  Regístrate aquí
                </button>
              </p>
            </CardFooter>
          </form>
        </Card>
      </div>
    </main>
  )
};

export default Register

